<template>
  <el-dialog
    width="360px"
    :title="$t('nickname.修改昵称')"
    v-bind="$attrs"
    class="dialog-dark"
    @open="onOpen"
    @close="onClose"
    v-on="$listeners"
  >
    <el-form
      ref="elForm"
      :model="form"
      :rules="rules"
      label-position="right"
      label-width="90px"
      class="form-dark"
      size="small"
      style="text-align: left; padding-right: 30px"
      @submit.native.prevent
    >
      <el-form-item :label="$t('nickname.新的昵称')" prop="nickname">
        <el-input
          v-model="form.nickname"
          :placeholder="$t('nickname.请输入昵称')"
          maxlength="20"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button class="button-mini" size="mini" @click="close">{{
        $t("nickname.取消")
      }}</el-button>
      <el-button class="button-mini" type="primary" size="mini" @click="ok">{{
        $t("nickname.确定")
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { setNickname } from "@/api/liveRequest/liveInfo";
import { mapGetters } from "vuex";
export default {
  name: "NickName",
  props: {},
  data() {
    return {
      form: {
        nickname: "",
      },
      uid:null
    };
  },
  computed: {
    ...mapGetters(["rtcClient","userInfo"]),
    rules() {
      return {
        nickname: [
          {
            required: true,
            message: this.$t("nickname.请输入昵称"),
            trigger: "blur",
          },
        ],
      };
    },
  },
  methods: {
    onOpen() {
      // const user = JSON.parse(sessionStorage.getItem("LoginInfo"));
      this.form.nickname = this.$parent.nickNameData.name
      this.uid =  this.$parent.nickNameData.uid
    },
    onClose() {
      this.$parent.nickNameData = null
      this.uid = null;
      this.$refs.elForm.resetFields();
    },
    close() {
      this.$emit("update:visible", false);
    },
    ok() {
      this.$refs.elForm.validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },
    async submit() {
      if(this.userInfo.uid == this.$parent.nickNameData.uid){
        this.uid = null
      }
      const { code, msg } = await setNickname(
        this.form.nickname,
        this.uid,
        this.$store.getters.liveToken
      );
      if (code === 200) {
        if(this.userInfo.uid == this.$parent.nickNameData.uid){
          const user = JSON.parse(sessionStorage.getItem("LoginInfo"));
          user.nickName = this.form.nickname;
          sessionStorage.setItem("LoginInfo", JSON.stringify(user));
          this.$store.commit(
            "SET_USERINFO",
            Object.assign(this.rtcClient.RTMSession.userInfo, {
              name: this.form.nickname,
            })
          );
        }
        this.$message.success(this.$t("nickname.昵称修改成功"));
        this.close();
      } else {
        this.$message.error(this.$t("nickname.必须为嘉宾角色"));
        this.close()
      }
    },
  },
};
</script>
